var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6.75V9H14.75V6.75C14.75 4.67812 13.0719 3 11 3C8.92813 3 7.25 4.67812 7.25 6.75ZM4.25 9V6.75C4.25 3.02344 7.27344 0 11 0C14.7266 0 17.75 3.02344 17.75 6.75V9H18.5C20.1547 9 21.5 10.3453 21.5 12V21C21.5 22.6547 20.1547 24 18.5 24H3.5C1.84531 24 0.5 22.6547 0.5 21V12C0.5 10.3453 1.84531 9 3.5 9H4.25Z",
    fill: "#FF9355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockImage);
export default __webpack_public_path__ + "static/media/lock-image.7d934a5712eeaa9e8012dc9cbc1167df.svg";
export { ForwardRef as ReactComponent };